<script setup lang="ts">
import type { PopoverRootEmits, PopoverRootProps } from "reka-ui";
import { useSidebarContextUnsafe } from "ls/features/sidebar/context";
import { PopoverRoot, useForwardPropsEmits } from "reka-ui";
import { onUnmounted } from "vue";

const props = withDefaults(defineProps<PopoverRootProps>(), {
  modal: true,
});

const emits = defineEmits<PopoverRootEmits>();
const forwarded = useForwardPropsEmits(props, emits);

const navigationContext = useSidebarContextUnsafe();
if (navigationContext) {
  const stop = navigationContext.observeMenu(() => props.open);
  onUnmounted(() => {
    stop();
  });
}
</script>

<template>
  <PopoverRoot v-bind="forwarded">
    <slot />
  </PopoverRoot>
</template>
